import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@components/common/card";
import { FINANCIAL_SERVER_URL, GET_MAIN_BOQ_ENDPOINT } from "@pma/utils/api-routes";
import axios from "axios";
import { parseCookies } from "nookies";
import { ACCESS_TOKEN } from "@pma/utils/constants";
import { useQuery } from "@tanstack/react-query";
import useTranslator from "@pma/hooks/use-translator";
import { DictType } from "@pma/types";
import BoQTable from "./boq-table";
import PmsLoader from "@components/common/loader";

interface BoQDetailsProps {
  boqId: string;
}

export type BoQItem = {
  id: string;
  price_item_id: number;
  number: string;
  description: string;
  estimate_boq_id: string;
  name: string;
  company_id: number;
  discount: number;
  discount_sum: number;
  initial_sum: number;
  real_sum: number;
  units: string;
  amount: number;
  wrong_cost: boolean;
  not_found: boolean;
  select_price_list: boolean;
  select_price_item_id: any[];
  boq_sum: number;
  paid: number;
  boq_cost: number;
  created_at: string;
  is_item: boolean;
  approved_amount: number;
  approved_initial_cost: number;
  discount_price: number;
  _amount_changes?: DictType;
};

export function MainBoQDetails({ boqId }: BoQDetailsProps) {
  const { translate } = useTranslator();

  const accessToken = parseCookies()[ACCESS_TOKEN];

  const getMainBoQDetails = async () => {
    const response = await axios.post(
      FINANCIAL_SERVER_URL + GET_MAIN_BOQ_ENDPOINT,

      {
        boq_id: boqId,
      },
      {
        headers: {
          Authorization: "Bearer " + accessToken,
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  };

  const {
    data: mainBoQDetails,
    isLoading: isLoadingMainBoQs,
    refetch: refetchMainBoQs,
  } = useQuery({
    queryKey: ["main-boq", boqId],
    queryFn: getMainBoQDetails,
  });

  const boqItems: BoQItem[] = mainBoQDetails?.boq_items || [];

  return (
    <Card className=''>
      <CardHeader>
        <CardTitle>{translate("BoQ Items")}</CardTitle>
        <CardDescription>
          {translate("View and approve (initial) individual BoQ items")}
        </CardDescription>
      </CardHeader>
      <CardContent className='p-0 rounded-none border-none'>
        <div className='space-y-4'>
          <div className=''>
            <div className='border-y last:border-b-0'>
              {isLoadingMainBoQs ? (
                <PmsLoader />
              ) : (
                <BoQTable
                  context='bill-preview'
                  data={boqItems}
                  boqId={boqId}
                  revalidate={refetchMainBoQs}
                />
              )}
              {boqItems?.length < 1 && !isLoadingMainBoQs && (
                <div className='w-full flex items-center justify-center py-4 text-sm font-medium'>
                  <p>{translate("No items found")}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
